import Vue from "vue";
import Vapi from "vuex-rest-api";
import Destination from "../models/Destination";
import AppEvents from "@/AppEvents";
import TransportationPermission from "../models/TransportationPermission";

interface IDestinationState {
  destinations: Destination[];
  transportPermissions: TransportationPermission[];
}

const destinationApi = new Vapi({
  baseURL: process.env.VUE_APP_API_HOST + "/api/Destination",
  state: {
    destinations: [],
    transportPermissions: []
  }
})
  .get({
    action: "getAllDestinations",
    property: "destinations",
    path: "/",
    onSuccess: (state: IDestinationState, payload, axios) => {
      state.destinations = payload.data.map(s => new Destination(s));
    },
    onError: (state: any, error: any, axios: any) => {
      AppEvents.handleApiError(error);
    }
  })
  .get({
    action: "getDestinationById",
    property: "destination",
    path: ({ id }) => "/" + id,
    onSuccess: (state: IDestinationState, payload, axios) => {
      // console.log("createDestination onSuccess", state, payload.data);
      const destination = new Destination(payload.data);
      const destinationIndex = state.destinations.findIndex(
        p => p.id === destination.id
      );
      if (destinationIndex > -1) {
        // destination already exists, update props
        Object.assign(state.destinations[destinationIndex], destination);
      } else {
        // destination does not exist, push it
        state.destinations.push(destination);
      }
    },
    onError: (state: any, error: any, axios: any) => {
      AppEvents.handleApiError(error);
    }
  })
  .get({
    action: "getTransportPermissions",
    property: "destinations",
    path: ({ destinationId }) =>
      "/" + destinationId + "/transportationpermissions",
    onSuccess: (state: IDestinationState, payload, axios) => {
      // console.log("createDestination onSuccess", state, payload.data);
      state.transportPermissions = [];
      state.transportPermissions = payload.data.map(d => new TransportationPermission(d));
    },
    onError: (state: any, error: any, axios: any) => {
      AppEvents.handleApiError(error);
    }
  })
  .post({
    action: "createDestination",
    property: "destination",
    path: "/",
    onSuccess: (state: IDestinationState, payload, axios) => {
      // console.log("createDestination onSuccess", state, payload.data);
      const destination = new Destination(payload.data);
      // destination does not exist, push it
      state.destinations.push(destination);
    },
    onError: (state: any, error: any, axios: any) => {
      AppEvents.handleApiError(error);
    }
  })
  .put({
    action: "updateDestination",
    property: "destination",
    path: ({ id }) => "/" + id,
    onSuccess: (state: IDestinationState, payload, axios) => {
      // console.log("createDestination onSuccess", state, payload.data);
      const destination = new Destination(payload.data);
      const destinationIndex = state.destinations.findIndex(
        p => p.id === destination.id
      );
      // destination already exists, update props
      Object.assign(state.destinations[destinationIndex], destination);
    },
    onError: (state: any, error: any, axios: any) => {
      AppEvents.handleApiError(error);
    }
  })
  .delete({
    action: "deleteDestination",
    property: "destination",
    path: ({ id }) => "/" + id,
    onSuccess: (state: IDestinationState, payload, axios) => {
      // console.log("deleteDestination onSuccess", state, payload.data);
      const destination = new Destination(payload.data);
      const destinationIndex = state.destinations.findIndex(
        p => p.id === destination.id
      );
      state.destinations.splice(destinationIndex, 1);
    },
    onError: (state: any, error: any, axios: any) => {
      AppEvents.handleApiError(error);
    }
  })
  .put({
    action: "undeleteDestination",
    property: "destination",
    path: ({ id }) => "/undelete/" + id,
    onSuccess: (state: IDestinationState, payload, axios) => {
      // console.log("undeleteDestination onSuccess", state, payload.data);
      const destination = new Destination(payload.data);
      const destinationIndex = state.destinations.findIndex(
        p => p.id === destination.id
      );
      if (destinationIndex > -1) {
        // destination already exists, update props
        Object.assign(state.destinations[destinationIndex], destination);
      } else {
        // destination does not exist, push it
        state.destinations.push(destination);
      }
    },
    onError: (state: IDestinationState, error: any, axios: any) => {
      AppEvents.handleApiError(error);
    }
  });

const destinationStore = destinationApi.getStore();
(destinationStore as any).namespaced = true;

destinationStore.mutations.addDestination = (state, value: Destination) => {
  state.destinations.push(value);
  (state.destinations as Destination[]).sort((a, b) => a.alias.localeCompare(b.alias));
}

export default destinationStore;
